<template>
  <nav ref="raceNavBar" class="navbar-expand-lg bb-navbar p-2 px-4">
    <div class="d-flex align-items-end mb-2">
      <!-- LOGO -->
      <img src="/bbLogo64Blue.png" />
      <router-link class="navbar-brand px-3 mb-1" :to="{ name: 'campaignsView' }">
        <span class="fw-lighter bb-app-heading">BATTLEBOARD</span>
      </router-link>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mt-2 align-items-end">
          <!-- username -->
          <span class="navbar-text me-3" style="color: grey">{{ user_name }}</span>
          <!-- avatar -->
          <li class="nav-item me-2">
            <img v-bind:src="avatar_image" height="70" width="70" class="rounded-circle bb-img" alt="Avatar" />
          </li>
          <!-- end items -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
// --------
// scripts
//---------
import { mapGetters } from 'vuex'
export default {
  name: 'RaceNavbar',
  data() {
    return {
      arena_name: '',
      arena_slug: '',
      user_name: '',
      avatar_image: null,
    }
  },
  //---------
  // methods
  //---------
  methods: {
    ...mapGetters('auth', {
      getUserProfile: 'getUserProfile',
      isAuthenticated: 'isAuthenticated',
    }),
    ...mapGetters('combat', {
      getCampaign: 'getCampaign',
    }),
    getCampaignHandler() {
      let campaign = this.getCampaign()
      this.arena_name = campaign.name
      this.arena_slug = campaign.slug
    },
    userProfileHandler() {
      let userProfile = this.getUserProfile()
      this.user_name = userProfile.user_name
      this.avatar_image = userProfile.avatar_image
    },
  },
  //---------
  // mounted
  //---------
  mounted() {
    this.getCampaignHandler()
    this.userProfileHandler()
  },
}
</script>